import React, { useEffect, useState } from 'react';

import { Box } from '@wds/box';
import AlertBanner from './AlertBanner';
import getComponentWithTheme from '../../../../themeProvider';

const SystemAlerts = () => {
	const [alerts, setAlerts] = useState();

	useEffect(() => {
		const url = reverse('user-alerts');
		fetch(url).then((response) => {
			if (!response.ok) throw new Error('Network response was not ok');
			return response.json();
		}).then((data) => {
			if (data && data.success && data.count > 0) {
				setAlerts(data.results);
			}
		});
	}, []);

	return (
		getComponentWithTheme(
			<Box className='alerts'>
				{alerts?.map((alert) => {
					const storageKey = `systemnotification-${alert.id}`;
					if (alert.id && !localStorage.getItem(storageKey)) {
						return (
							<AlertBanner
								key={`alert-${alert.id}`}
								alert={alert}
							/>
						);
					}
					return null;
				})}
			</Box>,
			window.LOCALE.theme,
		)
	);
};

export default SystemAlerts;
